import React, { useState, useEffect } from 'react';
import { apiService } from '../../services/api';

let _cache = null;

// Hook: carrega (com cache) os mapas de compartilhamento com sub-admins
export const useCompartilhamentos = () => {
  const [mapas, setMapas] = useState(
    _cache || { por_locacao: {}, por_moto: {}, por_placa: {}, por_cliente: {} }
  );

  useEffect(() => {
    if (_cache) return;
    apiService.api
      .get('/admin/compartilhamentos')
      .then((r) => {
        _cache = r.data;
        setMapas(r.data);
      })
      .catch((e) => console.debug('Falha ao carregar compartilhamentos:', e?.message));
  }, []);

  return mapas;
};

// Badge roxo "compartilhada com {usuário}"
export const CompartilhadaBadge = ({ nomes }) => {
  if (!nomes || nomes.length === 0) return null;
  return (
    <span
      className="inline-flex items-center gap-1 text-[10px] px-1.5 py-0.5 rounded-full bg-violet-500/20 text-violet-300 border border-violet-500/30 font-semibold whitespace-nowrap"
      title={`Compartilhada com: ${nomes.join(', ')}`}
      data-testid="badge-compartilhada"
    >
      👤 {nomes.join(', ')}
    </span>
  );
};
